/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './AddressDisplay.scss';

import classnames from 'classnames';
import { noop } from 'lodash';
import { func, object, shape, string } from 'prop-types';
import React from 'react';

import { AddressOption } from 'components/layouts/Preferences/UpdateContactInformation/MailingAddress/AddressTypeSelect';
import { formatMailingAddressLocation } from 'services/Formats';

const AddressDisplay = ({
  address,
  label,
  name,
  onClick,
  option,
  selected,
  mailingType
}) => {
  const isSelected = !option || option.value === selected; // No `option` provided means it's the only one, ergo, selected
  const className = classnames('address-validation-address', {
    selected: isSelected
  });
  return (
    <div className={className} onClick={onClick || noop}>
      <div className="address-label">
        {onClick && (
          <AddressOption
            onClick={onClick}
            option={option}
            selected={selected}
            mailingType={mailingType}
          />
        )}
        {!onClick && label}
      </div>
      <div className="validation-address-lines">
        {name}
        {address && address.addressLines && address.addressLines.map((addressLine, idx) => (
          <div key={idx}>{addressLine}</div>
        ))}
        <div>{formatMailingAddressLocation(address)}</div>
        <div>United States (US)</div>
      </div>
    </div>
  );
};

AddressDisplay.propTypes = {
  address: object.isRequired,
  label: string,
  name: string.isRequired,
  onClick: func,
  option: shape({
    label: string.isRequired,
    value: string.isRequired
  }),
  selected: string
};

export default AddressDisplay;
